<template>
  <Vacations :page="'edit'" />
</template>

<script>
import Vacations from '../../../Shared/Pages/Vacations/index.vue'

export default {
  components: {
    Vacations
  }
}
</script>
